document.addEventListener("DOMContentLoaded", () => {
    const gridWrap = document.getElementById("vardoGridWrap");
    const filtersButton = document.getElementById("collection_filters_button");
    const closeFiltersButton = document.getElementById(
        "filters_collection_close_button",
    );
    const filtersContainer = document.getElementById(
        "filters_collection_sidebar",
    );
    const overlay = document.getElementById("menu-vardo-overlay");

    overlay?.addEventListener("click", () => {
        closeFilters();
    });

    const openFilters = () => {
        filtersContainer?.classList.add("active");
        overlay?.classList.add("active");
    };

    const closeFilters = () => {
        overlay?.classList.remove("active");
        filtersContainer?.classList.remove("active");
    };

    const setLoading = (on) => {
        if (!gridWrap) return;
        gridWrap.classList.toggle("is-loading", on);
    };

    filtersButton?.addEventListener("click", openFilters);
    closeFiltersButton?.addEventListener("click", closeFilters);

    const applyAjaxFromUrl = async (url) => {
        try {
            setLoading(true);

            const res = await fetch(url, {
                method: "GET",
                headers: { "X-Requested-With": "XMLHttpRequest" },
            });

            if (!res.ok) throw new Error(`HTTP ${res.status}`);

            const html = await res.text();
            const doc = new DOMParser().parseFromString(html, "text/html");

            const newGrid = doc.querySelector("#product-grid");
            const currentGrid = document.querySelector("#product-grid");

            if (!newGrid || !currentGrid) {
                throw new Error("No se encontró #product-grid");
            }

            currentGrid.innerHTML = newGrid.innerHTML;
            window.history.replaceState({}, "", url);
        } catch (err) {
            console.error("AJAX falló, usando navegación normal:", err);
            window.location.href = url;
        } finally {
            setLoading(false);
        }
    };

    const sortInputs = document.querySelectorAll('input[name="vardo_sort_by"]');

    sortInputs.forEach((input) => {
        input.addEventListener("change", (e) => {
            if (!e.target.checked) return;

            const params = new URLSearchParams(window.location.search);
            params.set("sort_by", e.target.value);
            params.delete("page");

            const url = `${window.location.pathname}?${params.toString()}`;
            applyAjaxFromUrl(url);
        });
    });

    const priceBox = document.getElementById("filtersCollectionPrice");

    if (priceBox) {
        const priceToggle = document.getElementById(
            "filtersCollectionPriceToggle",
        );
        const priceBody = document.getElementById("filtersCollectionPriceBody");

        const minInput = document.getElementById("priceRangeMin");
        const maxInput = document.getElementById("priceRangeMax");
        const progress = document.getElementById("priceRangeProgress");
        const valuesText = document.getElementById(
            "filtersCollectionPriceValues",
        );
        const minLabel = document.getElementById("priceMinLabel");
        const maxLabel = document.getElementById("priceMaxLabel");

        const rangeWrap = priceBox.querySelector(
            ".filters-collection-price__range",
        );
        const min = Number(rangeWrap.dataset.min || 0);
        const max = Number(rangeWrap.dataset.max || 0);
        const gap = 1;

        let isApplyingPrice = false;

        const formatMoney = (value) => {
            return new Intl.NumberFormat("es-MX", {
                style: "currency",
                currency: "MXN",
                maximumFractionDigits: 0,
            }).format(value);
        };

        const normalizeRangeValues = () => {
            let minVal = Number(minInput.value);
            let maxVal = Number(maxInput.value);

            if (maxVal - minVal < gap) {
                if (document.activeElement === minInput) {
                    minVal = maxVal - gap;
                    minInput.value = minVal;
                } else {
                    maxVal = minVal + gap;
                    maxInput.value = maxVal;
                }
            }

            return {
                minVal: Number(minInput.value),
                maxVal: Number(maxInput.value),
            };
        };

        const updatePriceUI = () => {
            const { minVal, maxVal } = normalizeRangeValues();

            const left = ((minVal - min) / (max - min)) * 100;
            const right = ((maxVal - min) / (max - min)) * 100;

            progress.style.left = `${left}%`;
            progress.style.right = `${100 - right}%`;

            valuesText.textContent = `${formatMoney(minVal)} - ${formatMoney(maxVal)}`;
            minLabel.textContent = formatMoney(minVal);
            maxLabel.textContent = formatMoney(maxVal);
        };

        const applyPriceFilter = async () => {
            if (isApplyingPrice) return;

            const { minVal, maxVal } = normalizeRangeValues();
            const params = new URLSearchParams(window.location.search);

            params.delete("page");

            if (minVal > min) {
                params.set("filter.v.price.gte", minVal);
            } else {
                params.delete("filter.v.price.gte");
            }

            if (maxVal < max) {
                params.set("filter.v.price.lte", maxVal);
            } else {
                params.delete("filter.v.price.lte");
            }

            const url = `${window.location.pathname}?${params.toString()}`;
            const currentUrl = `${window.location.pathname}${window.location.search}`;

            if (url === currentUrl) return;

            isApplyingPrice = true;
            try {
                await applyAjaxFromUrl(url);
            } finally {
                isApplyingPrice = false;
            }
        };

        minInput?.addEventListener("input", updatePriceUI);
        maxInput?.addEventListener("input", updatePriceUI);

        minInput?.addEventListener("change", applyPriceFilter);
        maxInput?.addEventListener("change", applyPriceFilter);

        priceToggle?.addEventListener("click", () => {
            const expanded =
                priceToggle.getAttribute("aria-expanded") === "true";
            priceToggle.setAttribute("aria-expanded", String(!expanded));
            priceBody.classList.toggle("is-hidden");
        });

        updatePriceUI();
    }
});
